import React from "react";
import styled from "styled-components/macro";
import { PrimaryButton } from "../Buttons/Buttons";
import logoAlchemist from "./logo_alchemist.png";
import { spacingTokens } from "../../designTokens";

const BannerContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.resolve("spacing_2xl")};
  padding: ${({ theme }) => theme.resolve("spacing_xl")};
  background-color: ${({ theme }) => theme.tertiaryButtonBG};
  border: ${({ theme }) => theme.resolve("border_md")} solid
    ${({ theme }) => theme.primaryBorder};
  border-radius: ${({ theme }) => theme.resolve("radius_xs")};
  margin-bottom: ${({ theme }) => theme.resolve("spacing_2xl")};
`;

const LeftSection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
  flex: 1;
  min-width: 0;
`;

const LogoImage = styled.img`
  width: 24px;
  height: auto;
  flex-shrink: 0;
`;

const BannerText = styled.p`
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  font-size: ${({ theme }) => theme.resolve("font_size_base")};
  line-height: ${({ theme }) => theme.resolve("line_height_base")};
  color: ${({ theme }) => theme.primaryTextColor};
  margin: 0;
  white-space: nowrap;
`;

const CTASection = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.resolve("spacing_md")};
  flex-shrink: 0;
`;

interface AlchemistInsightsBannerProps {
  onViewDetails: () => void;
}

export const AlchemistInsightsBanner: React.FC<AlchemistInsightsBannerProps> =
  ({ onViewDetails }) => {
    return (
      <BannerContainer>
        <LeftSection>
          <LogoImage src={logoAlchemist} alt="Alchemist AI" />
          <BannerText>Alchemist Insights</BannerText>
        </LeftSection>
        <CTASection>
          <PrimaryButton
            onClick={onViewDetails}
            style={{
              height: "32px",
              padding: `${spacingTokens.spacing_sm} ${spacingTokens.spacing_lg}`,
            }}
          >
            View Details
          </PrimaryButton>
        </CTASection>
      </BannerContainer>
    );
  };
